export default [
    {
        text: 'código proveedor',
        value: 'provider_product_code',
    },
    {
        text: 'producto',
        value: 'wh_product_name',
    },
    {
        text: 'precio neto',
        value: 'net_price',
        format: 'currency',
    },
    {
        text: 'cantidad',
        value: 'quantity',
    },
    {
        text: 'total neto',
        value: 'net_total',
        format: 'currency',
    },
]
